import { usePostLogoutMutation } from 'api/auth/authApi';
import { useResetDashboardFilters } from 'pages/NewDashboard/useResetDashboardFilters';
import { useResetRunOrchestrationBanner } from 'pages/RunOrchestration/useResetRunOrchestrationBanner';
import { useCallback } from 'react';

// Shared by the header's logout button and the App-level inactivity timer
// so both clear persisted filters/banner state before ending the session.
export const useLogout = () => {
  const [logout] = usePostLogoutMutation();
  const resetDashboardFilters = useResetDashboardFilters();
  const resetRunOrchestrationBanner = useResetRunOrchestrationBanner();

  return useCallback(() => {
    resetDashboardFilters();
    resetRunOrchestrationBanner();
    logout(null);
  }, [logout, resetDashboardFilters, resetRunOrchestrationBanner]);
};
